import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useState } from 'react'
import { Container, Navigation } from './styles'
interface LabelType {
  url: String
  label: String
  active: Boolean
}

export function ListWithLogo(props: any) {
  const [pages, setPages] = useState<LabelType[]>(props.pages)

  return (
    <Container>
      <table>{props.children}</table>
      <Navigation>
        <div> 
          <p>{props.to} de {props.total} itens</p>
        </div>
        <div>
          {props.pages.map((page: LabelType) => {
            if (page.label === '&laquo; Anterior') {
              return(
              <button onClick={() => props.changeGet(page.url)}> <ChevronLeft size={16} /> </button>
              )
            } else if (page.label === 'Próximo &raquo;') {
              return(
              <button onClick={() => props.changeGet(page.url)}><ChevronRight size={16} /> </button>
              )
            } else {
              return (
                <button
                  onClick={() => props.changeGet(page.url)}
                  className={page.active ? 'active' : ''}
                >
                  {page.label}
                </button>
              )
            }
          })}
        </div>
        <div>
          <p>10 de 350 itens</p>
        </div>
      </Navigation>
    </Container>
  )
}
